import React, { Component } from 'reactn'
import { toast } from '../Components/ui'
import Config from '../Global/Config'
import { persistState, Api } from '../Services'
import logo from '../Assets/sanifrutta-logo.png'

export default class Login extends Component {
  constructor (props) {
    super(props)
    this.state = { user: '', psw: '' }
  }

  async login () {
    const { user, psw } = this.state

    if (!user || !psw) {
      toast.error('Completare tutti i campi, poi premere login')
      return
    }

    const data = await Api.login(user, psw)

    if (!data) {
      toast.error('Le credenziali immesse sono errate')
    } else {
      await this.setGlobal({ ...data, loggedIn: true }, persistState)
      this.props.postLogin()
    }
  }

  handleKeyDown (event) {
    if (event.key === 'Enter') this.login()
  }

  render () {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.logoBox}>
            <img src={logo} style={{ height: 50, width: 'auto' }} alt='Sanifrutta' />
          </div>
          <h2 style={styles.title}>Area riservata</h2>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Username</label>
            <input
              type='text'
              style={styles.input}
              value={this.state.user}
              onChange={e => this.setState({ user: e.target.value })}
            />
          </div>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Password</label>
            <input
              type='password'
              style={styles.input}
              value={this.state.psw}
              onChange={e => this.setState({ psw: e.target.value })}
              onKeyDown={e => this.handleKeyDown(e)}
            />
          </div>
          <button style={styles.btn} onClick={() => this.login()}>
            Accedi
          </button>
        </div>
        <div style={styles.footer}>
          &copy; 2026 Sanifrutta &mdash; Area amministrazione Joinfruit | v {Config.appVersion}
        </div>
      </div>
    )
  }
}

const styles = {
  page: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  card: {
    width: 380,
    maxWidth: '90vw',
    background: '#fff',
    borderRadius: 14,
    padding: 32,
    boxShadow: '0 24px 60px rgba(0,0,0,0.22)',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  logoBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 4
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 700,
    textAlign: 'center',
    margin: 0,
    color: '#1F2933'
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  label: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#3a4a3a'
  },
  input: {
    minHeight: 44,
    borderRadius: 8,
    border: '1px solid #cfd8cf',
    padding: '0 14px',
    fontSize: '0.95rem',
    outline: 'none'
  },
  btn: {
    minHeight: 44,
    borderRadius: 8,
    border: 'none',
    background: '#3D8B3F',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: 4
  },
  footer: {
    position: 'fixed',
    bottom: 16,
    width: '100%',
    textAlign: 'center',
    color: 'rgba(255,255,255,0.8)',
    fontSize: '0.8rem'
  }
}
